export default __webpack_public_path__ + "static/media/price.91edc102.svg";